import axios from "axios"

export default class ControllerCommands {
    sendControllerEvent(ev) {
        //console.log("send event: " + ev);
        axios.post("/games/sendcontroller", {event: ev})
    }
}
